<script setup lang="ts">
import { filterXSS } from 'xss';
import TripSegmentDetails from './TripSegmentDetails.vue';
import ReserveSidebar from './ReserveSidebar.vue';
import CardDescriptionView from '@components/util/CardDescriptionView.vue';
import type ItineraryPackage from '@itinerary/ItineraryPackage';

interface IProps {
    package: ItineraryPackage;
    showTermsAndConditions?: boolean;
    packageTerms?: string;
    accordionDefault?: 'opened' | 'closed';
}
const {
    package: pkg,
    packageTerms,
    showTermsAndConditions,
    accordionDefault = 'closed',
} = defineProps<IProps>();

const terms = computed(() => filterXSS(packageTerms ?? ''));

const serviceType = computed(() => pkg.serviceTypeText);
</script>

<template>
    <div
        class="package-info-container"
        :class="{
            label: !!serviceType,
        }"
    >
        <template v-if="pkg.isTripPackage()">
            <TripSegmentDetails
                v-for="(segment, key) in pkg.segments"
                :key
                :segment
                :price-class="
                    pkg.selectedPrice ?? pkg.defaultPrice ?? undefined
                "
                :initial-state="accordionDefault"
            />
            <template v-if="pkg.packageInfoDescription">
                <CardDescriptionView
                    v-for="info in pkg.packageInfoDescription"
                    :key="info.title"
                    :info
                />
            </template>
        </template>
        <template v-else-if="pkg.isHotelPackage()">
            <ReserveSidebar :item="pkg" />
        </template>
        <mr-accordion
            v-if="showTermsAndConditions && packageTerms"
            :initial-state="accordionDefault"
            :trigger-key="packageTerms"
            class="terms-root"
        >
            <template #title>
                <div class="title-container">
                    <mr-typography weight="500">
                        قوانین جریمه و استرداد
                    </mr-typography>
                    <mr-typography
                        v-if="serviceType"
                        class="service-label"
                        weight="500"
                        size="x-small"
                        color="var(--cool-gray-800)"
                    >
                        {{ serviceType }}
                    </mr-typography>
                </div>
            </template>
            <mr-typography
                size="small"
                align="justify"
                color="var(--cool-gray-800)"
                v-html="terms"
            />
        </mr-accordion>
    </div>
</template>

<style lang="scss" scoped>
.package-info-container {
    padding: 0 12px;
    background: white;
    @include shadow();
    border-radius: 10px;
    overflow: hidden;
    &.label {
        :deep(.header) {
            align-items: center;
            gap: 0;
        }
    }
}

.terms-root {
    padding-block: 8px;
    .title-container {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .service-label {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 28px;
            border-radius: 8px;
            padding: 1px 8px;
            background-color: usePalette($p-cool-gray, $p-100);
        }
    }
}
</style>
